
import { Vue, Component, Prop } from 'vue-property-decorator';

type ExportFormat = 'pdf' | 'excel' | 'zip';

@Component
export default class ExportMenu extends Vue {
    @Prop({ required: true })
    check!: (type: ExportFormat) => boolean;

    @Prop({ default: () => ['pdf', 'excel'] })
    formats!: ExportFormat[];

    @Prop({ default: false })
    loading!: boolean;

    @Prop({ default: false })
    inline!: boolean;

    get isDisabled(): boolean {
        return this.formats.every(format => !this.check(format));
    }

    emitDownload(type: ExportFormat) {
        this.$emit('download', type);
    }
}
